import { Bot } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ConversationHeaderProps {
  selectedCrewId: number | null;
  crewName?: string;
}

export const ConversationHeader: React.FC<ConversationHeaderProps> = ({
  selectedCrewId,
  crewName,
}) => {
  const { t } = useTranslation();

  if (!selectedCrewId) return null;

  return (
    <div className="bg-accent-50 dark:bg-accent-200/20 border-b border-accent-200 dark:border-accent-200 flex-shrink-0">
      <div className="flex items-center justify-center py-2 px-3">
        <div className="flex items-center space-x-2 text-accent-700 dark:text-accent-200">
          <Bot className="h-4 w-4 text-accent-700 dark:text-accent-200" />
          <span className="text-sm font-medium">
            {t('conversations.thisConversationUsing')}{' '}
            <span className="font-semibold">{crewName}</span>
          </span>
        </div>
      </div>
    </div>
  );
};
